import styled from "styled-components";
import { TabsTriggerLabelProps } from "../types";

/**
 * Label component for tab triggers - appears on the right side
 */
export const TriggerLabel = styled.div<TabsTriggerLabelProps>`
  margin-left: auto;
  font-family: "Open Sans";
  font-style: normal;
  font-size: 13px;
  line-height: 16px;
  color: var(--tab-granite-color, var(--granite));
  display: flex;
  align-items: center;
`;
